












































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import {
  required,
  requiredIf,
  numeric,
  minLength,
  maxLength,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
import moment from "moment";
import { BTabs, BTab, BFormDatepicker, BFormInput } from "bootstrap-vue";
import { VueEditor } from "vue2-editor";
import VueSelect from "vue-select";
import ModalHeader from "@/components/ModalHeader.vue";
import PatientSearch from "@/components/PatientSearch.vue";
import InputPopover from "@/components/InputPopover.vue";
import {
  Form,
  FormQuestion,
  GapPatientFilter,
  ScheduleAppointment,
  GapLogEntry,

} from "@/store/modules/types";
import {
  ScheduleType,
  ScheduleSession,
  SchedulePreReqType,
  GapLogType, 
} from "@/store/modules/enums";
import { fileIsImage, fileSize, fileIcon } from "@/utils";
import FormWizard from "@/components/FormWizard.vue";
import FormViewer from "@/components/FormViewer.vue";


@Component({
  components: {
    ModalHeader,
    BTabs,
    BTab,
    BFormDatepicker,
    BFormInput,
    VueSelect,
    VueEditor,
    PatientSearch,
    InputPopover,
    FormWizard,
    FormViewer,
  },
  computed: {
    ...mapState("auth", ["user", "entityId"]),
    ...mapState("schedule", ["calendars", "typeStatus"]),
  },
  validations: {
    appt: {
      main: {
        calendarId: {
          required,
        },
        reasonId: {
          required,
        },
        typeId: {
          required,
        },
        date: {
          required,
        },
        patient: {
          firstName: {
            required,
          },
          lastName: {
            required,
          },
          birth: {
            year: {
              //required,
              required: requiredIf((model) => {
                return model.day !== "" || model.month !== "";
              }),
              numeric,
            },
            month: {
              //required,
              required: requiredIf((model) => {
                return model.year !== "" || model.day !== "";
              }),
              numeric,
              minValue: minValue(0),
              maxValue: maxValue(11),
            },
            day: {
              //required,
              required: requiredIf((model) => {
                return model.year !== "" && model.month !== "";
              }),
              numeric,
              minValue: minValue(1),
              maxValue: maxValue(31),
            },
          },
          phone: {
            required,
            numeric,
            minLength: minLength(10),
          },
        },
        lang: {
          required,
        },
        statusId: {
          required,
        },
      },
      service: {
        description: {
          required,
        },
        address: {
          line1: {
            required,
          },
          city: {
            required,
          },
          state: {
            required,
            minLength: minLength(2),
            maxLength: maxLength(2),
          },
          zip: {
            required,
            minLength: minLength(5),
            maxLength: maxLength(10),
          },
          countryId: {
            required,
            minLength: minLength(2),
            maxLength: maxLength(2),
          },
        },
      },
    },
  },
})
export default class ApptEditor extends Vue {
  @Prop(Number) readonly apptId!: number;
  @Prop(Number) readonly patientId!: number;
  @Prop(String) readonly patientName!: string;
  @Prop(String) readonly patientPhone!: string;
  @Prop(String) readonly transportation!: string;
  @Prop(Boolean) readonly officeCall!: boolean;
  @Prop(Number) readonly gapId!: number;
  entityId!: number;
  calendars!: Array<any>;
  typeStatus!: Array<any>;
  reasons = Array<any>();
  priorities = Array<any>();
  insurers = Array<any>();
  links = Array<any>();
  calendar = {
    format: {
      year: "numeric",
      month: "short",
      day: "2-digit",
      weekday: "short",
    },
    minDate: new Date(),
    dates: Array<any>(),
    times: Array<any>(),
    fullDates: Array<string>(),
  };
  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
    ],
  };
  appt: ScheduleAppointment = {
    id: null,
    main: {
      calendarId: "",
      reasonId: "",
      priorityId: "",
      typeId: "APT",
      date: moment().format("YYYY-MM-DD"),
      time: "",
      sessionId: "",
      patient: {
        id: null,
        firstName: "",
        lastName: "",
        lastName2: "",
        birth: {
          year: "",
          years: [],
          month: "",
          monthDays: [],
          day: "",
          date: "",
        },
        phone: "",
        insurer: {
          id: "",
          memberId: "",
        },
        EMR_ID: "",
        email: "",
      },
      lang: "",
      statusId: "2",
      transportation: null,
      archived: false,
      officeCall:false
    },
    service: {
      description: "",
      address: {
        line1: "",
        line2: "",
        city: "",
        state: "",
        zip: "",
        countryId: "",
      },
    },
    prereqs: {
      list: [],
      selected: null,
    },
    files: [],
    comment: "",
  };
  prereqForm = {
    form: {} as Form,
    questions: Array<FormQuestion>(),
  };
  @Watch("appt.main.calendarId")
  onCalendarChanged(id: string) {
    if (id) {
      this.getReasons(id);
      this.getPriorities(id);
      this.getDates(id);
      this.getFullDates(id);
      this.getTimes();
      //if(!this.appt.main.lang)
      if(!this.appt.id)
      this.appt.main.lang = this.calendars.filter(
        (calendar) => calendar.id == id
      )[0].lang;

      this.getPreReqs();
    } else this.reasons = [];
  }
  @Watch("appt.main.reasonId")
  onReasonChanged(id: number) {
    if (id) {
      const reason = this.reasons.find((r) => r.id === id);
      if (reason) this.appt.main.typeId = reason.apptTypeId;
    } else {
      this.appt.main.typeId = "APT";
    }
    this.getPreReqs();
  }
  @Watch("appt.main.patient.birth", { deep: true })
  onBirthChanged(birth) {
    const birthdate = this.$moment([birth.year, birth.month, birth.day]);
    this.appt.main.patient.birth.date = birthdate.isValid()
      ? birthdate.format("YYYY-MM-DD")
      : "";
  }
  typeChanged(e) {
    this.appt.main.statusId = "2";
  }
  setPatient(patient, phoneType, phone) {
    // SET PATIENT
    const p = this.appt.main.patient;
    p.id = patient.id;
    p.firstName = patient.firstName;
    p.lastName = patient.lastName;
    p.lastName2 = patient.lastName2;
    // BIRTH
    const birthdate = moment(patient.birthdate);
    p.birth.year = birthdate.year().toString();
    p.birth.month = birthdate.month().toString();
    this.setBirthMonthDays();
    p.birth.day = birthdate.date().toString();
    //
    p.phone = phone;
    // CHECK INSURER
    const insurer =
      patient.insurerId &&
      this.insurers.find((i) => i.id === patient.insurerId);
    if (insurer) {
      p.insurer.id = patient.insurerId;
    }
    p.insurer.memberId = patient.insurerMemberId;
    // SET SERVICE ADDRESS
    const s = this.appt.service;
    s.address.line1 = patient.addressLine1;
    s.address.line2 = patient.addressLine2;
    s.address.city = patient.city;
    s.address.state = patient.state;
    s.address.zip = patient.zip;
    s.address.countryId = patient.countryId;
    // SET LANG
    if (patient.lang) this.appt.main.lang = patient.lang;
    //
  }
  setBirthMonthDays() {
    this.appt.main.patient.birth.monthDays = [];
    const { year, month } = this.appt.main.patient.birth;
    if (year === "" || month === "") {
      return;
    }
    const days = this.$moment([year, month]).daysInMonth();
    for (let i = 1; i <= days; i++) {
      this.appt.main.patient.birth.monthDays.push(i.toString());
    }
  }
  setBirthYears() {
    let year = this.$moment().year() - 115;
    while (year <= this.$moment().year()) {
      this.appt.main.patient.birth.years.push(year.toString());
      year++;
    }
  }
  prereqIcon(typeId: string) {
    switch (typeId) {
      case SchedulePreReqType.FILE:
        return "far fa-file-alt";
      case SchedulePreReqType.INFO:
        return "fas fa-info-circle";
      case SchedulePreReqType.PICTURE:
        return "far fa-file-image";
      case SchedulePreReqType.FORM:
        return "far fa-file-alt";
    }
  }
  clearPreReq(req) {
    this.$modal.show("dialog", {
      title: `Remove prerequisite '${req.name}'`,
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: () => {
            req.fileId = null;
            req.fileName = null;
            req.fileSize = null;
            req.fileKey = null;
            req.value = null;
            this.$modal.hide("dialog");
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  isDisabledDate(ymd: string, date: Date) {
    if (this.calendar.dates.length) {
      const weekday = moment(date).format("ddd").toUpperCase();
      let disabled = true;
      this.calendar.dates.forEach((item) => {
        if (item.date === "1900-01-01" && item.weekday === weekday) {
          disabled = item.disabled;
        } else if (item.date === ymd) {
          disabled = item.disabled;
        }
      });
      return disabled;
    } else {
      return false;
    }
  }
  getDateClass(ymd: string, date: Date) {
    if (this.calendar.fullDates.includes(ymd)) {
      return "full-date";
    }
    return null;
  }
  async getReasons(calendarId: string) {
    try {
      this.reasons = await this.$store.dispatch(
        "schedule/getCalendarReasons",
        calendarId
      );
      if (!this.apptId) {
        const defaultReason = this.reasons.find((r) => r.isDefault);
        if (defaultReason) {
          this.appt.main.reasonId = defaultReason.id;
        } else {
          this.getPreReqs();
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  async getPriorities(calendarId: string) {
    try {
      this.priorities = await this.$store.dispatch(
        "schedule/getCalendarPriorities",
        calendarId
      );
      if (!this.appt.id) {
        if (!this.priorities.length) {
          this.appt.main.priorityId = "";
        } else {
          this.appt.main.priorityId = this.priorities.filter(
            (p) => p.isDefault
          )[0]["id"];
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  async getDates(calendarId: string) {
    try {
      this.calendar.dates = await this.$store.dispatch(
        "schedule/getCalendarDates",
        calendarId
      );
    } catch (error) {
      console.log(error);
    }
  }
  async getFullDates(calendarId: string) {
    try {
      const data = await this.$store.dispatch(
        "schedule/getCalendarFullDates",
        calendarId
      );
      this.calendar.fullDates = data.map((item) => item.date);
    } catch (error) {
      console.log(error);
    }
  }
  async getTimes() {
    try {
      const { calendarId, date } = this.appt.main;
      const times = await this.$store.dispatch("schedule/getCalendarTimes", {
        calendarId,
        date,
      });
      if (times.length) {
        this.calendar.times = times;
      } else {
        await this.setTimes();
      }
    } catch (error) {
      console.log(error);
    }
  }
  async setTimes() {
    const { calendarId } = this.appt.main;
    const start = this.$moment("06:00", "HH:mm:ss");
    const end = this.$moment("20:00", "HH:mm:ss");
    let interval = 15;
    if (calendarId) {
      const calendar = this.calendars.find((c) => c.id === calendarId);
      if (calendar && parseInt(calendar.timeInterval)) {
        interval = parseInt(calendar.timeInterval);
      }
    }
    this.calendar.times = [];
    while (start.isBefore(end)) {
      this.calendar.times.push({
        apptCount: 0,
        apptLimit: 0,
        disabled: false,
        sessionLimit: 0,
        time: start.format("HH:mm:ss"),
      });
      start.add(interval, "m");
    }
  }
  async getInsurers() {
    try {
      this.insurers = await this.$store.dispatch(
        "schedule/getEntityInsurers",
        this.entityId
      );
    } catch (error) {
      console.log(error);
    }
  }
  async getAppt() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      // GET APPT INFO
      const data = await this.$store.dispatch(
        "schedule/getApptRecord",
        this.apptId
      );
      const { appt } = this;
      appt.id = data.id;
      appt.main.calendarId = data.calendarId;
      appt.main.reasonId = data.reasonId;
      appt.main.priorityId = data.priorityId;
      appt.main.typeId = data.typeId;
      appt.main.date = data.date;
      appt.main.time = data.time;
      appt.main.sessionId = data.sessionId;
      appt.main.patient.id = data.patientId;
      appt.main.patient.firstName = data.firstName;
      appt.main.patient.lastName = data.lastName;
      appt.main.patient.lastName2 = data.lastName2;
      appt.main.patient.phone = data.phone;
      appt.main.patient.email = data.email;
      appt.main.patient.insurer.id = data.insurerId;
      appt.main.patient.insurer.memberId = data.insurerMemberId;
      appt.main.patient.EMR_ID = data.PATIENT_EMR_ID;
      appt.main.lang = data.lang;
      appt.main.statusId = data.statusId;
      appt.main.transportation = data.transportation;
      appt.main.archived = data.archived;
      // BIRTH
      if (data.birthdate) {
        const birthdate = moment(data.birthdate);
        appt.main.patient.birth.year = birthdate.year().toString();
        appt.main.patient.birth.month = birthdate.month().toString();
        this.setBirthMonthDays();
        appt.main.patient.birth.day = birthdate.date().toString();
      }
      // SERVICE
      appt.service.description = data.serviceDescription;
      if (data.serviceAddress) {
        appt.service.address = JSON.parse(data.serviceAddress);
      }
      // GET TIMES
      this.getTimes();
      // GET ATTACHMENTS
      this.getFiles();
      // GET LINKS
      this.getLinks();
      //
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getPreReqs() {
    const calendarId = this.appt.main.calendarId;
    const apptTypeId = this.appt.main.typeId;
    const apptId = this.appt.id;
    try {
      this.appt.prereqs.list = await this.$store.dispatch(
        "schedule/getApptPreReqList",
        {
          calendarId,
          apptTypeId,
          apptId,
        }
      );
    } catch (error) {
      console.log(error);
    }
  }
  async getPatient() {
    try {
      const filter: GapPatientFilter = {
        id: this.patientId.toString(),
        firstName: "",
        lastName: "",
        insurerMemberId: "",
        EMR_ID: "",
        birthdateFrom: null,
        birthdateTo: null,
        city: "",
        gender: "",
        phone: "",
        insurerList: [],
        ipaList: [],
      };
      const patients = await this.$store.dispatch("gaps/getPatients", filter);
      const patient = patients[0];
      const phoneType = patient.mobilePhone
        ? "M"
        : patient.homePhone
        ? "H"
        : patient.otherPhone
        ? "O"
        : patient.otherPhone2
        ? "O"
        : "";
      const phone =
        patient.mobilePhone ||
        patient.homePhone ||
        patient.otherPhone ||
        patient.otherPhone2 ||
        "";
      this.setPatient(patient, phoneType, phone);
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getFiles() {
    try {
      this.appt.files = await this.$store.dispatch(
        "schedule/getApptFileList",
        this.apptId
      );
    } catch (error) {
      console.log(error);
    }
  }
  async getLinks() {
    try {
      this.links = await this.$store.dispatch("schedule/getLinks", this.apptId);
    } catch (error) {
      console.log(error);
    }
  }
  async fileView(file) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/viewFile", file);
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async fileDownload(fileKey: string) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/downloadFile", fileKey);
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async uploadFile() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const file = this.fileInput.files![0];
      const fileKeys = await this.$store.dispatch("schedule/uploadFile", file);
      const fileKey = fileKeys[0];
      let fileId = null;
      if (this.appt.id) {
        const data = await this.$store.dispatch("schedule/saveApptFile", {
          id: this.appt.id,
          key: fileKey,
        });
        fileId = data.fileId;
      }
      this.appt.files.push({
        id: fileId,
        key: fileKey,
        name: file.name,
        size: file.size,
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async uploadPreReqFile() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { selected } = this.appt.prereqs;
      const file = this.prereqFileInput.files![0];
      if (
        selected.typeId === SchedulePreReqType.PICTURE &&
        !fileIsImage(file.name)
      ) {
        this.$modal.show("dialog", {
          title: "WaitingMed",
          text: "File is not an image.",
        });
        return;
      }
      const fileKeys = await this.$store.dispatch("schedule/uploadFile", file);
      const fileKey = fileKeys[0];
      selected.fileName = file.name;
      selected.fileSize = file.size;
      selected.fileKey = fileKey;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async archiveFile(file) {
    if (file.id) {
      this.$modal.show("dialog", {
        title: "Remove " + file.name,
        text: "Are you sure?",
        buttons: [
          {
            title: "Yes",
            handler: async () => {
              this.$store.commit("main/SET_LOADING", true);
              try {
                const { id } = this.appt;
                const fileId = file.id;
                await this.$store.dispatch("schedule/archiveApptFile", {
                  id,
                  fileId,
                });
                this.$modal.hide("dialog");
                this.getFiles();
              } catch (error) {
                console.log(error);
              } finally {
                this.$store.commit("main/SET_LOADING", false);
              }
            },
          },
          {
            title: "No",
            default: true,
          },
        ],
      });
    }
  }
  async sendCall() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const result = await this.$store.dispatch(
        "schedule/sendApptCall",
        this.apptId
      );
      if (result.startsWith("OK")) {
        this.$modal.show("dialog", {
          title: "WaitingMed",
          text: "<b>Call</b> successfully sent.",
        });
      } else {
        this.$modal.show("dialog", {
          title: "WaitingMed",
          text: result,
        });
      }
    } catch (error) {

      if (error.response.data.startsWith("ERROR")) {
        this.$modal.show("dialog", {
          title: "WaitingMed",
          text: error.response.data,
        });
      }
      
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async sendSMS() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const result: string = await this.$store.dispatch(
        "schedule/sendApptSMS",
        this.apptId
      );
      if (result.startsWith("OK")) {
        this.$modal.show("dialog", {
          title: "WaitingMed",
          text: "<b>SMS</b> reminder successfully sent.",
        });
      } else if (result.startsWith("ERROR")) {
        this.$modal.show("dialog", {
          title: "WaitingMed",
          text: result,
        });
      }
    } catch (error) {
      if (error.response.data.startsWith("ERROR")) {
        this.$modal.show("dialog", {
          title: "WaitingMed",
          text: error.response.data,
        });
      }
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async save() {
    if (this.$v.appt.main!.$invalid) {
      this.$v.appt.main!.$touch();
      this.$modal.show("dialog", {
        title: "WaitingMed",
        text: "Main info is incorrect or incomplete.",
      });
      return;
    }
    if (this.isServiceAppt) {
      // if (this.$v.appt.service!.description.$invalid) {
      //   this.$v.appt.service!.$touch();
      //   this.$modal.show("dialog", {
      //     title: "WaitingMed",
      //     text: "Service description is incorrect or incomplete.",
      //   });
      //   return;
      // }
      if (this.$v.appt.service!.address.$invalid) {
        this.$v.appt.service!.$touch();
        this.$modal.show("dialog", {
          title: "WaitingMed",
          text: "Service address is incorrect or incomplete.",
        });
        return;
      }
    }
    // CHECK PREREQS
    // const { prereqs } = this.appt;
    // for (let i = 0; i < prereqs.list.length; i++) {
    //   const req = prereqs.list[i];
    //   if (!req.optional && !(req.value || req.fileKey)) {
    //     this.$modal.show("dialog", {
    //       title: "WaitingMed",
    //       text: `Prerequisite '<span class='wm-fw-500'>${req.name}</span>' not met.`,
    //     });
    //     return;
    //   }
    // }
    //
    this.$store.commit("main/SET_LOADING", true);
    try {

      await this.$store.dispatch("schedule/saveAppt", this.appt);

       if (this.appt.main.officeCall) {
        const entry: GapLogEntry = {
          gapId: this.gapId,
          statusId: "",
          subStatusId: "",
          //reasonId: null,
          typeId: GapLogType.OFFICE_CALL,
          comment: "",
        };
        await this.$store.dispatch("gaps/saveLog", entry);
      }

      this.$emit("appt-saved");
      this.close();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async saveNewLink(url: string) {
    if (!url) return;
    const { apptId } = this;
    const link = {
      apptId,
      id: null,
      url: url.toLowerCase(),
      description: "",
    };
    this.saveLink(link);
  }
  async saveLink(item) {
    try {
      const { apptId } = this;
      const { id, url, description } = item;
      await this.$store.dispatch("schedule/saveLink", {
        apptId,
        id,
        url,
        description,
      });
      this.$bvToast.toast(`Link saved!`, {
        title: "WaitingMed",
        toaster: "b-toaster-top-right",
        autoHideDelay: 2000,
        solid: true,
      });
      if (!item.id) this.getLinks();
    } catch (error) {
      console.log(error);
    }
  }
  async archiveLink(item) {
    this.$modal.show("dialog", {
      title: `Remove ${item.url}`,
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            try {
              const { apptId } = this;
              const { id } = item;
              await this.$store.dispatch("schedule/archiveLink", {
                apptId,
                id,
              });
              this.$bvToast.toast(`Link archived!`, {
                title: "WaitingMed",
                toaster: "b-toaster-top-right",
                autoHideDelay: 2000,
                solid: true,
              });
              this.getLinks();
              this.$modal.hide("dialog");
            } catch (error) {
              console.log(error);
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  async openForm(prereq: any, wizard: boolean) {
    this.prereqForm.form = {
      id: prereq.formId,
      name: prereq.name,
      hasAnswers: false,
    };
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { id } = this.appt;
      const { formId } = prereq;
      this.prereqForm.questions = await this.$store.dispatch(
        "schedule/getApptFormQuestions",
        {
          id,
          formId,
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
    if (wizard) {
      this.$modal.show("form-wizard");
    } else {
      this.$modal.show("form-viewer");
    }
  }
  async saveFormAnswers(answers) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { id } = this.appt;
      const formId = this.prereqForm.form.id;
      await this.$store.dispatch("schedule/saveApptFormAnswers", {
        id,
        formId,
        answers,
      });
      this.getAppt();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async close() {
    this.$modal.hide("appt-editor");
  }

  async archiveAppt() {
    if (this.appt.main.archived) {
      var time = this.calendar.times.filter(
        (t) => t.time == this.appt.main.time
      )[0];
      if (!time || time["disabled"]) {
        this.$modal.show("dialog", {
          title: "WaitingMed",
          text: "Time not available.",
        });
        return;
      }
    }

    this.$modal.show("dialog", {
      title: `${this.appt.main.archived ? "Unarchive" : "Archive"} Appt #${
        this.appt.id
      }`,
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.appt.main.archived = !this.appt.main.archived;
            this.save();
            this.$modal.hide("dialog");
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }

  get isServiceAppt() {
    if (!this.appt.main.typeId) {
      return false;
    }
    return this.appt.main.typeId !== ScheduleType.REGULAR;
  }
  get fileInput(): HTMLInputElement {
    return document.getElementById("fileInput") as HTMLInputElement;
  }
  get prereqFileInput(): HTMLInputElement {
    return document.getElementById("prereqFileInput") as HTMLInputElement;
  }
  get status() {
    return this.typeStatus.filter(
      (s) => s.apptTypeId === this.appt.main.typeId
    );
  }
  get ScheduleType() {
    return ScheduleType;
  }
  get ScheduleSession() {
    return ScheduleSession;
  }
  get SchedulePreReqType() {
    return SchedulePreReqType;
  }
  get scheduleTypeName() {
    switch (this.appt.main.typeId) {
      case ScheduleType.REGULAR:
        return "Appointment";
      case ScheduleType.DELIVERY:
        return "Delivery";
      case ScheduleType.READY_RESPONDERS:
        return "3-Way Home Service Appt.";
      case ScheduleType.SERVICE:
        return "Service";
      default:
        return "";
    }
  }
  get fileIcon() {
    return fileIcon;
  }
  get fileSize() {
    return fileSize;
  }
  mounted() {
    if (this.apptId) {
      this.getAppt();
    } else {
      const defaultCalendar = this.calendars.find((c) => c.isDefault);
      if (defaultCalendar) {
        this.appt.main.calendarId = defaultCalendar.id;
        this.appt.main.lang = defaultCalendar.lang;
      }
      if (this.patientId) {
        this.getPatient();
      }
      if (this.patientName) {
        if (this.patientName.includes(" ")) {
          const arr = this.patientName.split(" ");
          this.appt.main.patient.firstName = arr[0];
          this.appt.main.patient.lastName = arr[arr.length - 1];
        } else {
          this.appt.main.patient.firstName = this.patientName;
        }
      }
      if (this.patientPhone) {
        this.appt.main.patient.phone = this.patientPhone;
      }
      if (this.transportation != null) {
        this.appt.main.transportation = this.transportation;
      }
      if (this.officeCall) {
        this.appt.main.officeCall =  this.officeCall;
      }
    }
    this.getTimes();
    this.getInsurers();
    this.setBirthYears();
  }
}
